document.addEventListener('DOMContentLoaded',function(){
  var toggle=document.querySelector('[data-menu-toggle]');
  var menu=document.querySelector('[data-mobile-menu]');
  if(toggle&&menu){toggle.addEventListener('click',function(){var open=menu.classList.toggle('is-open');toggle.setAttribute('aria-expanded',open?'true':'false');toggle.setAttribute('aria-label',open?'Close menu':'Open menu');});}
});
(function () {
  function initialise(root) {
    root.querySelectorAll('[data-nexilia-product]').forEach(function (section) {
      if (section.dataset.pickerReady) return;
      var data = section.querySelector('[data-variant-data]');
      var picker = section.querySelector('[data-option-picker]');
      if (!data || !picker) return;
      var variants = JSON.parse(data.textContent);
      var fields = Array.from(picker.querySelectorAll('fieldset'));
      var idInput = section.querySelector('[data-variant-id]');
      var price = section.querySelector('[data-variant-price]');
      var button = section.querySelector('[data-add-to-bag]');
      var status = section.querySelector('[data-variant-status]');
      var form = idInput.closest('form');
      function update(changeUrl) {
        var selected = fields.map(function (field) {
          var checked = field.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        var variant = variants.find(function (item) {
          return item.options.every(function (value, index) { return value === selected[index]; });
        });
        idInput.value = variant ? String(variant.id) : '';
        idInput.disabled = !variant || !variant.available;
        button.disabled = !variant || !variant.available;
        button.textContent = !variant ? 'Unavailable' : variant.available ? 'Add to bag' : 'Sold out';
        price.innerHTML = variant ? variant.price : 'Unavailable';
        status.textContent = !variant ? 'This combination is unavailable. Please choose another option.' : !variant.available ? 'This combination is sold out.' : '';
        if (changeUrl) {
          var url = new URL(window.location.href);
          if (variant) url.searchParams.set('variant', variant.id);
          else url.searchParams.delete('variant');
          window.history.replaceState({}, '', url);
        }
      }
      picker.addEventListener('change', function () { update(true); });
      form.addEventListener('submit', function (event) {
        if (button.disabled || idInput.disabled || !idInput.value) event.preventDefault();
      });
      update(false);
      section.querySelector('[data-variant-fallback]').hidden = true;
      picker.hidden = false;
      section.dataset.pickerReady = 'true';
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
})();

/* NEXILIA v5 gallery: native touch swipe, keyboard arrows, thumbnails, image zoom */
(function(){
  function setupGallery(root){
    var galleries=[];
    if(root.matches && root.matches('[data-nexilia-gallery]')) galleries.push(root);
    root.querySelectorAll('[data-nexilia-gallery]').forEach(function(g){galleries.push(g)});
    galleries.forEach(function(gallery){
      if(gallery.dataset.galleryReady) return;
      var viewport=gallery.querySelector('[data-gallery-viewport]');
      if(!viewport) return;
      var slides=Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      var thumbs=Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      var count=gallery.querySelector('[data-gallery-count]');
      var prev=gallery.querySelector('[data-gallery-prev]');
      var next=gallery.querySelector('[data-gallery-next]');
      var dialog=gallery.querySelector('[data-gallery-lightbox]');
      var dialogImage=gallery.querySelector('[data-gallery-lightbox-image]');
      var close=gallery.querySelector('[data-gallery-lightbox-close]');
      var active=0;
      function setActive(index){
        active=Math.max(0,Math.min(slides.length-1,index));
        if(count)count.textContent=(active+1)+' / '+slides.length;
        thumbs.forEach(function(t,i){
          t.classList.toggle('is-active',i===active);
          t.setAttribute('aria-current',i===active?'true':'false');
        });
      }
      function goTo(index){
        index=Math.max(0,Math.min(slides.length-1,index));
        viewport.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        setActive(index);
      }
      thumbs.forEach(function(t,i){t.addEventListener('click',function(){goTo(i)})});
      if(prev)prev.addEventListener('click',function(){goTo(active===0?slides.length-1:active-1)});
      if(next)next.addEventListener('click',function(){goTo(active===slides.length-1?0:active+1)});
      var raf=null;
      viewport.addEventListener('scroll',function(){
        if(raf)cancelAnimationFrame(raf);
        raf=requestAnimationFrame(function(){
          var index=Math.round(viewport.scrollLeft/Math.max(1,viewport.clientWidth));
          setActive(index);
        });
      },{passive:true});
      viewport.addEventListener('keydown',function(event){
        if(event.target.tagName==='BUTTON')return;
        if(event.key==='ArrowRight'){event.preventDefault();goTo(Math.min(active+1,slides.length-1))}
        if(event.key==='ArrowLeft'){event.preventDefault();goTo(Math.max(active-1,0))}
      });
      gallery.querySelectorAll('[data-gallery-zoom]').forEach(function(button){
        button.addEventListener('click',function(){
          if(!dialog || !dialog.showModal)return;
          var img=button.querySelector('img');if(!img)return;
          dialogImage.src=img.currentSrc||img.src;dialogImage.alt=img.alt;
          dialog.showModal();
        });
      });
      if(close)close.addEventListener('click',function(){dialog.close()});
      if(dialog)dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close()});
      gallery.dataset.galleryReady='true';
    });
  }
  document.addEventListener('DOMContentLoaded',function(){setupGallery(document)});
  document.addEventListener('shopify:section:load',function(event){setupGallery(event.target)});
})();
